module.exports = __webpack_public_path__ + "assets/media/w3.41f8b261.mp4";